<div class="comment-container" [formGroup]="formGroup">

  <div formArrayName="comments" class="comments-list">
    <div *ngFor="let comment of comments.controls; let i = index"
         class="comment-card"
         [class.is-checked]="isChecked(i)"
         [formGroupName]="i">

      <div class="comment-header">
        <nb-user *ngIf="(getCreatedBy(i) | async) as author"
                 size="small"
                 [name]="author.firstName + ' ' + author.lastName"
                 [picture]="getUserProfile(author)">
        </nb-user>
        <div class="comment-meta">
          <span class="comment-time" *ngIf="getCreated(i)">{{ getCreated(i) }}</span>
          <span class="meta-sep" *ngIf="isEdited(i)">·</span>
          <span class="tag-edited" *ngIf="isEdited(i)">bearbeitet</span>
          <ng-container *ngIf="checkedBy(i) as cb">
            <span class="meta-sep">·</span>
            <nb-icon icon="checkmark-circle-2-outline" pack="eva" class="icon-checked"></nb-icon>
            <span class="tag-checked">{{ cb.firstName }} {{ cb.lastName }}</span>
          </ng-container>
        </div>
        <div class="comment-actions">
          <button nbButton ghost size="tiny" status="success"
                  (click)="uncheck(i)" *ngIf="isChecked(i)"
                  [disabled]="comments.disabled" nbTooltip="Als offen markieren">
            <nb-icon pack="eva" icon="checkmark-circle-2-outline"></nb-icon>
          </button>
          <button nbButton ghost size="tiny" status="basic"
                  (click)="check(i)" *ngIf="!isChecked(i)"
                  [disabled]="comments.disabled" nbTooltip="Als erledigt markieren">
            <nb-icon pack="eva" icon="radio-button-off-outline"></nb-icon>
          </button>
          <button nbButton ghost size="tiny" status="danger"
                  (click)="removeComment(i)"
                  [disabled]="comments.disabled" nbTooltip="Kommentar entfernen">
            <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
          </button>
        </div>
      </div>

      <textarea class="comment-text" formControlName="text" rows="2"
                [readOnly]="!(canEdit(comment.get('createdBy')?.value, currentUser$ | async))"
                placeholder="Kommentar eingeben...">
      </textarea>

    </div>
  </div>

  <div class="no-comments" *ngIf="comments.controls.length === 0">
    <nb-icon icon="message-circle-outline" pack="eva"></nb-icon>
    <span>Noch keine Kommentare</span>
  </div>

  <button nbButton ghost status="primary" size="small"
          (click)="addComment()" [disabled]="comments.disabled">
    <nb-icon pack="eva" icon="plus-circle-outline"></nb-icon>
    Kommentar hinzufügen
  </button>

</div>
